import TextInputField from "@/components/design-system/textInputField";
import { ComponentProps, FunctionComponent } from "react";

const EMAIL_PATTERN = "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,24}$";
const EMAIL_REGEX = new RegExp(`^${EMAIL_PATTERN}`);

export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value);

type TextInputFieldProps = ComponentProps<typeof TextInputField>;
type EmailInputProps = Omit<TextInputFieldProps, "type" | "pattern">;

const EmailInput: FunctionComponent<EmailInputProps> = ({
  label = "Email address",
  autoComplete = "email",
  errorMessage = "Please enter a valid email address",
  showLeftIcon = false,
  showRightIcon = false,
  ...rest
}) => (
  <TextInputField
    type="email"
    pattern={EMAIL_PATTERN}
    label={label}
    autoComplete={autoComplete}
    errorMessage={errorMessage}
    showLeftIcon={showLeftIcon}
    showRightIcon={showRightIcon}
    {...rest}
  />
);

export default EmailInput;
